import React, { useContext } from 'react';
import { SelfServiceLayout } from 'src/self-service/components/SelfServiceLayout';
import { AddUserForm } from './AddUserForm';
import { useAddUserToAccountMutation } from 'src/state/slice/umsServiceApi';
import {
  IAddUserToAccountRequest,
  IdentityTypes,
} from 'src/state/slice/models/CaseLifecycleTypes';
import { UMS_ACCOUNT_ENTITY_CLASS } from 'src/constants/GlobalConstants';
import { AuthContext } from 'src/state/providers/AuthProvider';
import { KatAlert } from '@amzn/katal-react';
import { fetchAPIErrorMessage } from 'src/state/slice/utils/apiUtils';
import { logger } from 'src/logger';
import { ADD_USER_PAGE } from 'src/self-service/constants/SelfServiceConstants';

export interface AddUserFormData {
  userType: string;
  accountId: string;
  roleName: string;
  email?: string;
  alias?: string;
}
export const AddUser = () => {
  const [addUserToAccount, { isError, error, isSuccess }] =
    useAddUserToAccountMutation();
  const { clientId } = useContext(AuthContext);

  const onSubmit = (data: AddUserFormData) => {
    logger.info('Add user generated payload is: ', { data });
    const payload: IAddUserToAccountRequest = {
      user: {
        userId:
          data.userType == IdentityTypes.INTERNAL_USER_ALIAS
            ? data.alias
            : data.email,
        attributes: {
          role: data.roleName,
        },
        type: data.userType as IdentityTypes,
      },
      account: {
        accountId: data.accountId,
        accountType: UMS_ACCOUNT_ENTITY_CLASS,
      },
      clientId: clientId,
      identity: { userId: '' },
    };
    addUserToAccount(payload);
  };
  return (
    <>
      {isError && (
        <KatAlert
          variant="danger"
          description={fetchAPIErrorMessage(
            error,
            ADD_USER_PAGE.ADD_USER_DEFAULT_ERROR_MESSAGE,
          )}
        ></KatAlert>
      )}
      {isSuccess && (
        <KatAlert
          variant="success"
          description={ADD_USER_PAGE.ADD_USER_SUCCESS_MESSAGE}
        ></KatAlert>
      )}
      <SelfServiceLayout
        header={ADD_USER_PAGE.PAGE_HEADER}
        body={<AddUserForm onSubmit={onSubmit} />}
      />
    </>
  );
};
